import { toIsoDate } from "@/lib/utils";
import type {
  AppointmentCreate,
  AppointmentUpdate,
} from "@/types/appointments/api-types/appointment-types";
import type { AddAppointmentFormValues } from "@/zod-schemas/appointments/add-appointment-schema";
import type { EditAppointmentFormValues } from "@/zod-schemas/appointments/edit-appointment-schema";

export function toAppointmentCreate(
  values: AddAppointmentFormValues
): AppointmentCreate {
  return {
    client_id: values.client_id,
    appointment_date: toIsoDate(values.appointment_date),
    status: "booked",
    services: values.services.map((line) => ({
      service_id: line.service_id,
      staff_id: line.staff_id,
      start_time: line.start_time,
      duration_minutes: line.duration_minutes,
      price: line.price,
    })),
  };
}

export function toAppointmentUpdate(
  values: EditAppointmentFormValues
): AppointmentUpdate {
  return {
    appointment_date: toIsoDate(values.appointment_date),
    status: values.status,
    services: values.services.map((line) => ({
      service_id: line.service_id,
      staff_id: line.staff_id,
      start_time: line.start_time,
      duration_minutes: line.duration_minutes,
      price: line.price,
    })),
  };
}
